import { FiLogIn } from "react-icons/fi";
import { FiLogOut } from "react-icons/fi";
import { IoManOutline } from "react-icons/io5";
import { HiUserGroup } from "react-icons/hi2";
import { LuPartyPopper } from "react-icons/lu";
export default function Policy() {
  return (
    <>
      <div className="container py-5">
        <div className="text-center wow fadeInUp">
          <h6 className="section-title text-center text-warning text-uppercase">
            Policies
          </h6>
          <h1 className="">
            Policies of
            <span className="text-warning text-uppercase"> BGM HOTEL</span>
          </h1>
        </div>
        {/* <h3>Policies</h3> */}
        <div className="border rounded p-3 col-12 mb-4">
          <div className="row p-4">
            <div className="col-6 pt-4 pb-4">
              <FiLogIn /> &nbsp; Check-in
            </div>
            <div className="col-6 pt-4 pb-4">From 12:00</div>
            <hr />
            <div className="col-6 pt-4 pb-4">
              <FiLogOut /> &nbsp; Check-Out
            </div>
            <div className="col-6 pt-4 pb-4">Until 11:00</div>
            <hr />
            <div className="col-6 pt-4 pb-4">
              <IoManOutline /> &nbsp; Age restriction
            </div>
            <div className="col-6 pt-4 pb-4">
              <li>The minimum age for check-in is 18</li>
              <li>Unmarried Couple strictly Not Allowed</li>
            </div>
            <hr />
            <div className="col-6 pt-4 pb-4">
              <HiUserGroup /> &nbsp; Groups
            </div>
            <div className="col-6 pt-4 pb-4">
              When booking more than 6 rooms, different policies and additional
              supplements may apply.
            </div>
            <hr />
            <div className="col-6 pt-4 pb-4">
              <LuPartyPopper /> &nbsp; Parties
            </div>
            <div className="col-6 pt-4 pb-4">
              For Parties / events Booking Accepted
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
